module.exports = __webpack_public_path__ + "static/img/6.5255f83.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/sp/6.png
// module id = UZIJ
// module chunks = 0